import Header from "../headers/header";
import Footer from "../footers/footer";
import { Outlet } from "react-router-dom";
import LoginSignUpModal from "../modal/LoginSignupModal";
import ForgotPassword from "../modal/ForgotPassword";
import Loader from "../loader/Loader";
import SnackBar from "../alert/snackBar";
import LinearLoaderBar from "../loader/linearLoader";
import { useSelector } from "react-redux";
import { createContext, useCallback, useContext, useMemo, useState } from "react";

export const HomeSearchContext = createContext(null);

export const useHomeSearch = () => useContext(HomeSearchContext);

export default function Layout(){
 const linearLoader=useSelector(state=>state.common.linearLoader);
 const [searchBridge, setSearchBridge] = useState(null);
 const [showMobileHeaderSearch, setShowMobileHeaderSearchState] = useState(false);
 const [showDesktopHeaderSearch, setShowDesktopHeaderSearchState] = useState(false);
 const [mobileEventHeaderTitle, setMobileEventHeaderTitle] = useState('');
 const [showMobileEventHeaderTitle, setShowMobileEventHeaderTitleState] = useState(false);

 const registerSearch = useCallback((bridge) => {
   setSearchBridge(bridge);
 }, []);

 const unregisterSearch = useCallback(() => {
   setSearchBridge(null);
   setShowMobileHeaderSearchState(false);
   setShowDesktopHeaderSearchState(false);
 }, []);

 const setShowMobileHeaderSearch = useCallback((value) => {
   setShowMobileHeaderSearchState(value);
 }, []);

 const setShowDesktopHeaderSearch = useCallback((value) => {
   setShowDesktopHeaderSearchState(value);
 }, []);

 const registerEventHeader = useCallback((bridge) => {
   setMobileEventHeaderTitle(bridge?.title ?? '');
 }, []);

 const unregisterEventHeader = useCallback(() => {
   setMobileEventHeaderTitle('');
   setShowMobileEventHeaderTitleState(false);
 }, []);

 const setShowMobileEventHeaderTitle = useCallback((value) => {
   setShowMobileEventHeaderTitleState(value);
 }, []);

 const homeSearchValue = useMemo(
   () => ({
     searchBridge,
     registerSearch,
     unregisterSearch,
     showMobileHeaderSearch,
     setShowMobileHeaderSearch,
     showDesktopHeaderSearch,
     setShowDesktopHeaderSearch,
     mobileEventHeaderTitle,
     showMobileEventHeaderTitle,
     registerEventHeader,
     unregisterEventHeader,
     setShowMobileEventHeaderTitle,
   }),
   [
     searchBridge,
     registerSearch,
     unregisterSearch,
     showMobileHeaderSearch,
     setShowMobileHeaderSearch,
     showDesktopHeaderSearch,
     setShowDesktopHeaderSearch,
     mobileEventHeaderTitle,
     showMobileEventHeaderTitle,
     registerEventHeader,
     unregisterEventHeader,
     setShowMobileEventHeaderTitle,
   ]
 );

    return (
        <HomeSearchContext.Provider value={homeSearchValue}>
        <Header/>
        <Outlet/>
        <Footer/>
        <LoginSignUpModal/>
        <ForgotPassword/>
        <Loader/>
        <SnackBar/>
        {linearLoader && <LinearLoaderBar/>}
        </HomeSearchContext.Provider>
    );
}
